<template>
<div class="container">
<div class="row">
	<img :src="picurl+'images/mobile/about.png'" alt="第一健康">
</div>
 <div class="content" v-html="info.content" v-if="info"></div>
</div>	
</template>

<style scoped>
.content{padding:1rem .5rem;}	
</style>

<script>


export default {
	data:function(){
		return {
			info:"",
			picurl:picurl,
		}
	},
	created:function(){
		window.scrollTo(0,0);
		mydata.header=true;
		this.init();
	},
	methods:{
		init:function(){
			var _this=this;
            if(fun.cache(fun.url())){
            	this.info=fun.cache(fun.url());return;
            }
			fun.post(api+"about",{},function(d){
				console.log(d);
				if(d.status==1){
					_this.info=d.info;
					fun.cache(fun.url(),d.info);
				}else{
					_this.$toast(d.info);
				}
			})
		}
	},
}	
</script>


// WEBPACK FOOTER //
// src/components/other/about.vue